var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.98438C7 3.24959 7.10536 3.50395 7.29289 3.69148C7.48043 3.87902 7.73478 3.98438 8 3.98438C8.26522 3.98438 8.51957 3.87902 8.70711 3.69148C8.89464 3.50395 9 3.24959 9 2.98438C9 2.71916 8.89464 2.4648 8.70711 2.27727C8.51957 2.08973 8.26522 1.98438 8 1.98438C7.73478 1.98438 7.48043 2.08973 7.29289 2.27727C7.10536 2.4648 7 2.71916 7 2.98438ZM7 7.98438C7 8.24959 7.10536 8.50395 7.29289 8.69148C7.48043 8.87902 7.73478 8.98438 8 8.98438C8.26522 8.98438 8.51957 8.87902 8.70711 8.69148C8.89464 8.50395 9 8.24959 9 7.98438C9 7.71916 8.89464 7.46481 8.70711 7.27727C8.51957 7.08973 8.26522 6.98438 8 6.98438C7.73478 6.98438 7.48043 7.08973 7.29289 7.27727C7.10536 7.46481 7 7.71916 7 7.98438ZM7 12.9844C7 13.2496 7.10536 13.5039 7.29289 13.6915C7.48043 13.879 7.73478 13.9844 8 13.9844C8.26522 13.9844 8.51957 13.879 8.70711 13.6915C8.89464 13.5039 9 13.2496 9 12.9844C9 12.7192 8.89464 12.4648 8.70711 12.2773C8.51957 12.0897 8.26522 11.9844 8 11.9844C7.73478 11.9844 7.48043 12.0897 7.29289 12.2773C7.10536 12.4648 7 12.7192 7 12.9844Z",
    fill: "#485365"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.c0ca327ef667a31d7875de8c5df6c5f4.svg";
export { ForwardRef as ReactComponent };